import React, { useState } from 'react';
import { GoverningData } from '../common/Data';
import style from '../../css/Governing.module.css';
import Dropdown from 'react-dropdown';
import { FaChevronDown } from 'react-icons/fa'; 

function Governing() {
	const [showIndex, setShowIndex] = useState(0);

	return (
		<div className={style.hcf}>
			<p className={style.head}>Governing Bodies</p>
			<div className={style.container}>
				{GoverningData.map((item) => (
					<div key={item.id}>
						<p
							className={item.id === showIndex ? style.active_txt : style.txt}
							onClick={() => {
								setShowIndex(item.id);
							}}
						>
							{item.title}
						</p>
					</div>
				))}
			</div>
			<div className={style.dorpCon}>
				<Dropdown
					options={GoverningData.map((data) => data.title)}
					onChange={(selected) => {
						const selectedIndex = GoverningData.findIndex(
							(data) => data.title === selected.value
						);
						setShowIndex(selectedIndex);
					}}
					value={GoverningData[showIndex].title}
					className={style.dropdown}
					menuClassName={style.option}
				/>
				<FaChevronDown size={10} color="grey" className={style.icon} />
			</div>

			<div className={style.row_div}>
				<img
					src={GoverningData[showIndex].image}
					alt="Image"
					className={style.image}
				/>
				<div className={style.icon_row}>
					<p className={style.name}>{GoverningData[showIndex].name}</p>
					<p className={style.decp}>{GoverningData[showIndex].decp}</p>
					<p className={style.exp}>{GoverningData[showIndex].explination}</p>
				</div>
			</div>
		</div>
	);
}

export default Governing;
